<template>
  <div :id="element" :class="classname"></div>
</template>

<script>
import ApexCharts from 'apexcharts'

export default {
  name: 'ApexChart',
  props: {
    element: {
      type: String,
      required: true
    },
    chartOption: {
      type: Object,
      required: true
    },
    classname: {
      type: String,
      default: ''
    },
    isLive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      chart: null,
      lastDate: 0,
      data: [],
      TICKINTERVAL: 86400000,
      XAXISRANGE: 777600000,
      prevOptions: null  // 이전 옵션을 저장하기 위한 변수 추가
    }
  },
  watch: {
      chartOption: {
          handler(newVal, oldVal) {
              if (this.chart && newVal && this.hasChanges(newVal, oldVal)) {
                  this.chart.updateOptions(newVal, true, true);  // 애니메이션 없이 업데이트
              }
          },
          deep: true
      }
  },
  methods: {
    // 옵션 변경 여부를 확인하는 메소드
    hasChanges(newVal, oldVal) {
      if (!oldVal || !newVal) return true;

      try {
        // series 데이터 비교
        let hasSeriesChanges = false;
        if (Array.isArray(newVal.series) && Array.isArray(oldVal.series)) {
          hasSeriesChanges = JSON.stringify(newVal.series) !== JSON.stringify(oldVal.series);
        } else {
          // 하나라도 배열이 아니면 변경으로 간주
          hasSeriesChanges = true;
        }

        // xaxis categories 비교
        let hasXAxisChanges = false;
        const newCategories = newVal.xaxis?.categories;
        const oldCategories = oldVal.xaxis?.categories;

        if (Array.isArray(newCategories) && Array.isArray(oldCategories)) {
          hasXAxisChanges = JSON.stringify(newCategories) !== JSON.stringify(oldCategories);
        } else {
          // 하나라도 배열이 아니면 변경으로 간주
          hasXAxisChanges = true;
        }

        return hasSeriesChanges || hasXAxisChanges;
      } catch (error) {
        // Error comparing chart options
        return true; // 오류 발생 시 변경으로 간주
      }
    },

    initChart() {
      try {
        if (!this.element || !this.chartOption) {
          // Missing element or chartOption
          return;
        }

        const selector = '#' + this.element;
        const element = document.querySelector(selector);

        if (!element) {
          // Element not found
          return;
        }

        // Ensure chartOption has valid series and xaxis categories
        if (!this.chartOption.series) {
          // Missing series in chartOption
          this.chartOption.series = [];
        }

        if (!this.chartOption.xaxis || !this.chartOption.xaxis.categories || !Array.isArray(this.chartOption.xaxis.categories)) {
          // Missing or invalid xaxis categories
          if (!this.chartOption.xaxis) {
            this.chartOption.xaxis = {};
          }
          this.chartOption.xaxis.categories = [1];
        }

        // Validate series data
        if (Array.isArray(this.chartOption.series)) {
          this.chartOption.series = this.chartOption.series.map(series => {
            if (!series) return { name: 'Unknown', data: [0] };

            // Ensure name is a string
            if (!series.name || typeof series.name !== 'string') {
              series.name = 'Unknown';
            }

            // Ensure data is an array
            if (!series.data || !Array.isArray(series.data)) {
              series.data = [0];
            } else {
              // Filter out null/undefined values
              series.data = series.data.map(val => (val === null || val === undefined) ? 0 : val);
            }

            return series;
          });
        }

        if (this.chart) {
          this.chart.destroy();
        }


        this.chart = new ApexCharts(element, this.chartOption);
        this.chart.render();

        // 초기 옵션 저장
        this.prevOptions = JSON.parse(JSON.stringify(this.chartOption));

        if (this.isLive) {
          setInterval(() => {
            this.getNewSeries(this.lastDate, {
              min: 10,
              max: 90
            });
            this.chart.updateSeries([{
              data: this.data
            }]);
          }, 1000);
        }
      } catch (error) {
        // Chart initialization error
      }
    },
    getNewSeries(baseval, yrange) {
      const newDate = baseval + this.TICKINTERVAL;
      this.lastDate = newDate;

      if (Array.isArray(this.data)) {
        for (let i = 0; i < this.data.length - 10; i++) {
          this.data[i].x = newDate - this.XAXISRANGE - this.TICKINTERVAL;
          this.data[i].y = 0;
        }
        this.data.push({
          x: newDate,
          y: Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min
        });
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initChart();
      }, 100);
    });
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  }
}
</script>